export default "__VITE_ASSET__B$Twtas9__"